<script>
    import {USER_ROLES} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import UserEditModal from "../users/UserEditModal.svelte";
    import {copyObjectData} from "../lib/lib";

    export let transporter = null;

    let userId = null;

    const onCreate = () => {
        userId = 0;
    }

    const onEdit = (user) => {
        userId = user.id;
    }

    // const onDelete = (userObj) => {
    //     Alert.delete("Delete User", `This will permanently delete user "${userObj.name}".\nAre you sure?`, () => deleteUser(userObj.id));
    // }
    //
    // const deleteUser = (id) => {
    //     // let ids = department.users.map(item => (item.id)).filter(x => x != id);
    //     // save(ids);
    // }

    const closeEdit = (userObj) => {
        if (userObj) {
            let item = transporter.users.find(x => x.id == userObj.id);
            if (item) {
                copyObjectData(userObj, item, true);
                transporter.users = transporter.users;
            } else {
                transporter.users = [userObj, ...transporter.users];
            }
        }
        userId = null;
    }
</script>

<div class="panel panel-default">
    <div class="panel-heading py-2">
        Users
        <button class="btn btn-primary btn-sm py-1" on:click="{ onCreate }" disabled="{ transporter.id == 0 }">
            CREATE USER
        </button>
    </div>
    {#if transporter.id > 0}
        {#if transporter.users.length}
            <table class="table table-list">
                <tbody>
                {#each transporter.users as item}
                    <tr class="row-hover">
                        <td>
                            <span class="is-link" class:not-active={ item.is_active < 1 } on:click="{ () => onEdit(item) }">
                                { item.name }
                            </span>
                        </td>
<!--                        <td class="button-column pointer" title="delete user" on:click="{ () => onDelete(item) }">-->
<!--                            <AppIcon icon="trash" size="16"/>-->
<!--                        </td>-->
                    </tr>
                {/each}
                </tbody>
            </table>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new transport company in order to add users
        </div>
    {/if}
</div>
{#if userId != null}
    <UserEditModal {userId} transporterId="{ transporter.id }" closeCallback="{ closeEdit }"/>
{/if}